import SignupFormCard from './SignupFormCard';

export default SignupFormCard;
